import React from "react";
import { Nav, NavItem, Button } from "reactstrap";
import ToolbarWrapper from "../../../../system/containers/Table/components/Toolbar";
import { checkPermissions } from "../../../../system/utils/UserPermissions";

const Toolbar = props => {
  return (
    <ToolbarWrapper>
      <Nav>
        {checkPermissions(props.permissions, ["ALL", "DELETE_**"]) && (
          <NavItem>
            <Button size="sm" onClick={() => props.handleDelete()}>
              <i className="far fa-trash-alt" /> Delete Selected
            </Button>
          </NavItem>
        )}
        <NavItem>
        <Button size="sm" onClick={() => props.export()}>Export</Button>
        </NavItem>
        <NavItem className="ml-auto">{props.total} Entries</NavItem>
      </Nav>
    </ToolbarWrapper>
  );
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/containers/Enquiries/HolidayEnquiry/components/Toolbar.jsx